import { db, storage } from '../../../firebase'

const actions = {
    // UPLOAD FILE
    uploadFileToStore({ commit }, payload) {
        return new Promise((resolve, reject) => {
            var storageRef = storage.ref(payload.filePath)

            storageRef.put(payload.file)
            .then(() => {
                console.log('Uploaded ' + payload.file.name)
                storageRef.getDownloadURL()
                .then((url) => { 
                    console.log('Url of the uploaded file is ' + url)
                    resolve(url)
                })
                .catch((error) => {
                    reject(error)
                })
            })
            .catch(() => console.log('Error while uploading ' + payload.file.name))    
        })
    },


    
    // CREATE POST
    async createBlogPost({ commit }, { post, deltaEn, deltaHu }) {
        var docRef = await db
            .collection('blog')
            .doc(post.slug)

        try {
            return docRef.get().then((doc) => {
                if (doc.exists) {
                    alert('Document already exists. Use another slug.')
                    return false
                } else {
                    (async () => {
                        var postRef = db
                            .collection('blog')
                            .doc(post.slug)

                        var deltaEnRef = db
                            .collection('blog')
                            .doc(post.slug)
                            .collection('quill')
                            .doc('deltaEn')

                        var deltaHuRef = db
                            .collection('blog')
                            .doc(post.slug)
                            .collection('quill')
                            .doc('deltaHu')

                        console.log(post, deltaEn)
                        await postRef.set(post)
                        await deltaEnRef.set(deltaEn)
                        await deltaHuRef.set(deltaHu)
                    })()

                    return true
                }
            })
        } catch(err) {
            console.log(err)
            return false
        }
    },



    // FETCH POSTS
    async fetchPosts({ commit }, { visibility, commitName, limit, authorID }) {
        if(authorID) {
            var postRef = await db
                .collection('blog')
                .where('author', '==', authorID)
                .where('visibility', '==', visibility)
                .orderBy('uploadTime', 'desc')
                .limit(limit)
                .get()
        } else {
            var postRef = await db
                .collection('blog')
                .where('visibility', '==', visibility)
                .orderBy('uploadTime', 'desc')
                .limit(limit)
                .get()
        }

        const posts = postRef.docs.map(post => ({
            id: post.id,
            ...post.data()
        }))

        for (var post of posts) {
            var userRef = await db
                .collection('users')
                .doc(post.author)
                .get()

            post.author = {
                id: userRef.id,
                ...userRef.data()
            }
        }

        commit(commitName, posts)
    },

    async purgeUserPosts({ commit }) {
        const empty = []

        commit('setUserPosts', empty)
        commit('setDraftPosts', empty)

        commit('reachedBottom', false)
        commit('draftsReachedBottom', false)
    },

    
    async fetchPostsAfter({ commit }, { visibility, commitName, lastVisible, limit, authorID, feedType }) {
        var lastVisibleDoc = await db
            .doc('blog/' + lastVisible.id)
            .get()

        if(authorID) {
            var postsRef = await db
                .collection('blog')
                .where('author', '==', authorID)
                .where('visibility', '==', visibility)
                .orderBy('uploadTime', 'desc')
                .startAfter(lastVisibleDoc)
                .limit(limit)
                .get()
        } else {
            var postsRef = await db
                .collection('blog')
                .where('visibility', '==', visibility)
                .orderBy('uploadTime', 'desc')
                .startAfter(lastVisibleDoc)
                .limit(limit)
                .get()
        }

        const posts = postsRef.docs.map(post => ({
            id: post.id,
            ...post.data()
        }))

        for (var post of posts) {
            var userRef = await db
                .collection('users')
                .doc(post.author)
                .get()

            post.author = {
                id: userRef.id,
                ...userRef.data()
            }
        }

        if(posts.length < limit) {
            if(feedType === 'userDrafts') {
                commit('draftsReachedBottom', true)
            } else {
                commit('reachedBottom', true)
            }
        }

        commit(commitName, posts)
    },

    setReachedBottomToDefault({commit}) {
        commit('reachedBottom', false)
    },

    setDraftsReachedBottomToDefault({commit}) {
        commit('draftsReachedBottom', false)
    },




    // FETCH SINGLE POST BY ID
    async fetchPostByID({ commit }, id) {
        try {
            const postRef = await db
                .collection('blog')
                .doc(id)
                .get()

            const deltaEnRef = await db
                .collection('blog')
                .doc(id)
                .collection('quill')
                .doc('deltaEn')
                .get()

            const deltaHuRef = await db
                .collection('blog')
                .doc(id)
                .collection('quill')
                .doc('deltaHu')
                .get()

            const postData = postRef.data()

            const authorRef = await db
                .collection('users')
                .doc(postData.author)
                .get()

            postData.author = {
                id: authorRef.id,
                ...authorRef.data()
            }

            const deltaEnData = deltaEnRef.data()
            const deltaHuData = deltaHuRef.data()
            
            const result = Object.assign(postData, deltaEnData, deltaHuData)

            commit('setBlogPost', result)
        } catch(error) {
            console.log(error)
            return error
        }
    },



    // UPDATE POST
    async updatePost({ commit }, { postId, updatedContent, updatedDeltaEn, updatedDeltaHu }) {
        try {
            await db
                .collection('blog')
                .doc(postId)
                .update(updatedContent)

            await db
                .collection('blog')
                .doc(postId)
                .collection('quill')
                .doc('deltaEn')
                .set(updatedDeltaEn)

            await db
                .collection('blog')
                .doc(postId)
                .collection('quill')
                .doc('deltaHu')
                .set(updatedDeltaHu)

                return true
        } catch(err) {
            console.log(err)
            return false
        }
    },

    // UPDATE COVER
    async updateCover({ commit }, { postId, updatedCover, oldCover }) {
        try {
            await db
                .collection('blog')
                .doc(postId)
                .update(updatedCover)

            var storageRef = storage.refFromURL(oldCover)
            await storageRef.delete()
            console.log(storageRef + ' deleted')

            return true
        } catch(err) {
            console.log(err)
            return false
        }
    },

    // DELETE POST
    async deletePost({ commit }, { id, imageUrl }) {
        db
            .collection('blog')
            .doc(id)
            .delete()

        db
            .collection('blog')
            .doc(id)
            .collection('quill')
            .doc('deltaHu')
            .delete()

        db
            .collection('blog')
            .doc(id)
            .collection('quill')
            .doc('deltaEn')
            .delete()
        
        var storageRef = storage.refFromURL(imageUrl)
        console.log(storageRef)
        try {
            await storageRef.delete()
            return true
        } catch(err) {
            console.log(err)
            return false
        }
    },
}

export default actions